import React from 'react';

interface IProps {
  style?: any;
}

const TextIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg" style={props.style}>
        <path d="M9.67033 0V1.90996C9.67033 2.17699 9.45385 2.39347 9.18681 2.39347C8.93885 2.39347 8.73447 2.20681 8.70654 1.96634L8.7033 1.90996V0.967033L5.1978 0.966546V10.033H6.52747C6.79451 10.033 7.01099 10.2494 7.01099 10.5165C7.01099 10.7644 6.82433 10.9688 6.58385 10.9968L6.52747 11H2.65934C2.3923 11 2.17582 10.7835 2.17582 10.5165C2.17582 10.2685 2.36249 10.0641 2.60296 10.0362L2.65934 10.033H4.23077V0.966546L0.967033 0.967033V1.9068C0.967033 2.17384 0.750555 2.39031 0.483517 2.39031C0.235552 2.39031 0.0311766 2.20365 0.00324627 1.96318L0 1.9068V0H9.67033Z" fill="black"/>
    </svg>

  )
}

export default TextIcon;